const prices = [
  {
    titleUa: "Діагностика",
    titleEn: "",
    price: "300",
  },
  {
    titleUa: "Виклик майстра",
    titleEn: "",
    price: "500",
  },

  {
    titleUa: "Установка Windows + драйвери + стартові програми",
    titleEn: "Installation Windows + drivers",
    price: "1000",
  },
  {
    titleUa: "Установка Office (Word, Exel, PDF)",
    titleEn: "Installation Windows + drivers + Office (Word, Exel, PowerPoint)",
    price: "500",
  },
  {
    titleUa: "Чистка від пилу ноутбука, заміна термопасти, рідкого металу",
    titleEn: "Cleaning laptop from dust with replacement of thermal paste",
    price: "1000-2000",
  },

  {
    titleUa: "Заміна оперативної пам'яті у ноутбуці",
    titleEn: "Replacing RAM in a laptop",
    price: "700",
  },
  {
    titleUa: "Заміна оперативної пам'яті у стаціонарному комп'ютері",
    titleEn: "Replacing RAM in a desktop computer",
    price: "700",
  },
  {
    titleUa: "Заміна відеокарти у ноутбуці",
    titleEn: "Replacing a video card in a laptop",
    price: "1500-4000",
  },
  {
    titleUa: "Заміна відеокарти у стаціонарному комп'ютері",
    titleEn: "Replacing a video card in a desktop computer",
    price: "700",
  },
  {
    titleUa: "Заміна диска-накопичувача в ноутбуці",
    titleEn: "Replacing a hard drive in a laptop",
    price: "700",
  },
  {
    titleUa: "Заміна диска-накопичувача в стаціонарному комп'ютері",
    titleEn: "Replacing a hard drive on a desktop computer",
    price: "700",
  },
  {
    titleUa: "Заміна материнської плати у стаціонарному комп'ютері",
    titleEn: "Replacing the motherboard in a PC",
    price: "1000",
  },
  {
    titleUa: "Заміна материнської плати ноутбука",
    titleEn: "Laptop motherboard replacement",
    price: "1500",
  },
  {
    titleUa: "Заміна блоку живлення",
    titleEn: "Replacing the power supply",
    price: "700",
  },

  {
    titleUa: "Заміна клавіатури в ноутбуці",
    titleEn: "",
    price: "1200",
  },
  {
    titleUa: "Заміна роз'єму живлення в ноутбуці",
    titleEn: "",
    price: "1100",
  },
  {
    titleUa: "Збірка комп'ютера",
    titleEn: "Computer assembly",
    price: "1500",
  },
  //   {
  //     titleUa: '',
  //     titleEn: '',
  //     price: '',
  //   },
  //   {
  //     titleUa: '',
  //     titleEn: '',
  //     price: '',
  //   },
  //   {
  //     titleUa: '',
  //     titleEn: '',
  //     price: '',
  //   },
  //   {
  //     titleUa: '',
  //     titleEn: '',
  //     price: '',
  //   },
  //   {
  //     titleUa: '',
  //     titleEn: '',
  //     price: '',
  //   },
  //   {
  //     titleUa: '',
  //     titleEn: '',
  //     price: '',
  //   },
]

export default prices
